/**
 * @genesis_domain Routing Core
 * @genesis_version V9.1
 * @genesis_intent Public-only route guard — renders children only when unauthenticated, redirects to / otherwise
 * @genesis_boundaries No business logic, no API calls, pure routing guard
 * @genesis_ai_trail V9.0: Created during flat declarative route tree refactor to prevent authenticated users from accessing login/signup pages.
 */

import { Navigate, Outlet } from 'react-router-dom';

import { GlassLoadingSpinner } from '@/components/feedback/GlassLoadingSpinner';
import { useAuth } from '@/context/AuthContext';

export function PublicOnlyGuard() {
    const { isInitializing, isAuthenticated } = useAuth();

    if (isInitializing) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center">
                <GlassLoadingSpinner
                    message="Loading..."
                    size="md"
                    fullScreen={false}
                />
            </div>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
}
